var _defs, _path, _path2, _polyline, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _polyline2, _polyline3, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _polyline4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g2, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle, _path52, _path53, _g3, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _polygon, _path61, _polygon2, _path62, _path63, _path64, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _polygon3, _path65, _polygon4, _path66, _path67, _path68, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _polygon5, _path69, _polygon6, _path70;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawGoal0V5V1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1144.4,
    height: 798.9,
    viewBox: "0 0 1144.4 798.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2e6f350-b5ca-4a1b-97fa-8ad82b1378fe-176",
    x1: 774.13,
    y1: 337.35,
    x2: 774.13,
    y2: 337.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 1184, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e032e4db-4b5a-4772-82a4-e151341a8119-177",
    x1: 511.77,
    y1: 675.55,
    x2: 511.77,
    y2: 284.01,
    xlinkHref: "#e2e6f350-b5ca-4a1b-97fa-8ad82b1378fe-176"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "796bd2e3-6922-48c9-8d61-1a37047129f5-178",
    x1: 518.3,
    y1: 270.01,
    x2: 518.3,
    y2: 195.01,
    xlinkHref: "#e2e6f350-b5ca-4a1b-97fa-8ad82b1378fe-176"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd3c50c2-1925-4067-85c5-f26d2d595195-179",
    x1: 1016.25,
    y1: 529.56,
    x2: 1016.25,
    y2: 466.66,
    xlinkHref: "#e2e6f350-b5ca-4a1b-97fa-8ad82b1378fe-176"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1c0a27d4-1f07-420a-99e3-d67bda5d7f31-180",
    x1: 1039.34,
    y1: 567.37,
    x2: 1039.34,
    y2: 504.47,
    xlinkHref: "#e2e6f350-b5ca-4a1b-97fa-8ad82b1378fe-176"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "goal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.19,119.74c3.72,31.61,29.81,56.64,36,87.86A85.19,85.19,0,0,1,65.61,220c.89,17.93-2.66,36.23-.83,54.19,3.41,33.68,23.88,60,49.87,82.81,19.66,17.21,42.48,32.35,63.47,47,53.44,37.33,103.56,84.46,125.51,145.84,14.63,40.93,15.75,85.41,26.49,127.53s35.2,85.22,76.54,98.65c44.37,14.42,93.26-9.62,138.92-.12,49,10.2,83.75,56.51,132.1,69.59,61.43,16.62,122.65-24.22,185.71-32.73,30.28-4.09,61.1-.62,91.54-3.24A230.08,230.08,0,0,0,1051,779c10-5.87,20.11-13.08,24.76-23.74,4-9.21,3.39-19.71,2.16-29.68-4.6-37-16.24-77.22,2.07-109.74,16.89-30,57.82-51.46,51.75-85.33-3.65-20.39-23.69-33.12-42.27-42.25-38.32-18.83-79.14-33.57-113.39-59-24.5-18.22-45.6-43.64-54.6-72.23A96.31,96.31,0,0,1,917,321.59c1.26-18.9,7.8-40.12-3.6-55.25-4.94-6.56-12.51-10.59-20.12-13.67-28.7-11.6-60.58-12.27-90.42-20.51A124.73,124.73,0,0,1,773.6,220c-18.2-10.54-32.85-26.07-36.39-46.34-2.07-11.88-.23-24.85-6.16-35.35-10-17.8-29.77-25.24-51.85-27.66-27.33-3-58.28,1.69-79,4l-2.07.22c-26.61,2.77-53-3.12-78.93-12-28-9.51-55.37-22.45-82-31.65q-3.75-1.3-7.48-2.49A383,383,0,0,0,370.2,54.88a389.12,389.12,0,0,0-86-3.32,381.53,381.53,0,0,0-43.38,5.64q-6.32,1.2-12.62,2.57c-24.42,5.23-48.71,11.62-73.62,12-1.79,0-3.59,0-5.38,0-29.71-.51-60.09-8.06-88.28,1.06C48.1,77,35.81,85.2,30.65,97.64,27.78,104.57,27.32,112.3,28.19,119.74Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.61,220H91.28a34,34,0,0,1,22.34-30,24,24,0,1,1,23.15,0,34,34,0,0,1,22.34,30h.22a34,34,0,0,1,22.28-29,24,24,0,1,1,35.17-25.41,33.93,33.93,0,0,1,9.83-5.59,24,24,0,1,1,23.15,0,34,34,0,0,1,22.42,32v28h11V198a34,34,0,0,1,22.42-32,24,24,0,1,1,23.15,0,34.1,34.1,0,0,1,19.6,18.44A34.09,34.09,0,0,1,364.63,172a24,24,0,1,1,23.15,0,34.11,34.11,0,0,1,17.42,14.23V182a34,34,0,0,1,22.42-32,24,24,0,1,1,23.15,0,34,34,0,0,1,22.42,32v38h12a34.09,34.09,0,0,1,19.39-18,24,24,0,1,1,23.15,0,33.87,33.87,0,0,1,6.76,3.35A34,34,0,0,1,556.63,178a24,24,0,1,1,23.15,0,34.07,34.07,0,0,1,21,22.4,34,34,0,0,1,13.82-9.4,24,24,0,1,1,23.15,0,33.93,33.93,0,0,1,10.08,5.8A34.1,34.1,0,0,1,667.63,178a24,24,0,1,1,23.15,0,34,34,0,0,1,22.42,32v10h60.4a124.73,124.73,0,0,0,29.25,12.15c29.84,8.24,61.72,8.91,90.42,20.51,7.61,3.08,15.18,7.11,20.12,13.67,11.4,15.13,4.86,36.35,3.6,55.25A96.31,96.31,0,0,0,921.44,357H114.65c-26-22.76-46.46-49.13-49.87-82.81C63,256.24,66.5,237.94,65.61,220Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "993.9 76.97 993.9 464.96 973.9 451.96 973.9 76.97 961.9 76.97 956.9 438.96 937.9 424.96 950.9 71.97",
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1018.91,
    y1: 104.97,
    x2: 937.91,
    y2: 109.47,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 124.97,
    x2: 937.91,
    y2: 127.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 148.97,
    x2: 937.91,
    y2: 150.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 170.97,
    x2: 937.91,
    y2: 173.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 195.97,
    x2: 934.91,
    y2: 195.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 220.97,
    x2: 932.91,
    y2: 217.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 243.97,
    x2: 932.91,
    y2: 239.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1013.91,
    y1: 268.97,
    x2: 932.91,
    y2: 262.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1015.91,
    y1: 290.97,
    x2: 929.91,
    y2: 282.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1015.91,
    y1: 315.97,
    x2: 929.91,
    y2: 302.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1015.91,
    y1: 344.97,
    x2: 926.91,
    y2: 328.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1015.91,
    y1: 377.97,
    x2: 926.91,
    y2: 351.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1017.91,
    y1: 411.97,
    x2: 923.91,
    y2: 374.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1017.91,
    y1: 442.97,
    x2: 923.91,
    y2: 396.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "915.9 75.97 899.9 416.96 878.9 416.96 891.9 75.97 868.9 75.97 853.9 416.96 830.9 416.96 843.9 75.97 815.9 75.97 805.9 416.96 780.9 416.96 791.9 78.97 765.9 78.97 759.9 416.96 736.9 416.96 743.9 75.97 720.9 75.97 715.9 416.96 693.9 416.96 698.9 75.97 672.9 75.97 672.9 416.96 646.9 416.96 646.9 75.97 622.9 75.97 626.9 416.96 605.9 416.96 599.9 75.97 575.9 75.97 583.9 416.96 562.9 416.96 552.9 75.97 531.9 75.97 539.9 416.96 520.9 416.96 505.9 75.97 485.9 75.97 501.9 416.96 481.9 416.96 459.9 75.97 435.9 75.97 463.9 416.96 444.9 416.96 417.9 75.97 398.9 75.97 426.9 416.96 405.9 416.96 378.9 71.97 359.9 71.97 390.9 416.96 370.9 416.96 338.9 71.97",
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "293.9 76.97 323.9 422.96 308.9 434.96 285.9 76.97 269.9 76.97 285.9 447.96 262.9 462.96 253.91 71.97",
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 115.97,
    x2: 323.91,
    y2: 115.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 140.97,
    x2: 323.91,
    y2: 140.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 168.97,
    x2: 323.91,
    y2: 165.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 192.97,
    x2: 327.91,
    y2: 187.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 219.97,
    x2: 327.91,
    y2: 215.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 248.97,
    x2: 331.91,
    y2: 243.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 276.97,
    x2: 331.91,
    y2: 266.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 308.97,
    x2: 331.91,
    y2: 284.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 336.97,
    x2: 335.91,
    y2: 301.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 231.91,
    y1: 365.97,
    x2: 335.91,
    y2: 325.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 228.91,
    y1: 393.97,
    x2: 332.44,
    y2: 350.52,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 228.91,
    y1: 425.97,
    x2: 335.91,
    y2: 371.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 228.91,
    y1: 454.97,
    x2: 338.91,
    y2: 393.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 937.91,
    y1: 104.97,
    x2: 323.91,
    y2: 109.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 937.41,
    y1: 122.97,
    x2: 323.41,
    y2: 127.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 936.91,
    y1: 140.97,
    x2: 322.91,
    y2: 145.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 936.41,
    y1: 158.97,
    x2: 322.41,
    y2: 163.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 935.91,
    y1: 176.97,
    x2: 321.91,
    y2: 181.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 935.41,
    y1: 194.97,
    x2: 329.41,
    y2: 199.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 934.91,
    y1: 212.97,
    x2: 328.91,
    y2: 217.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 934.41,
    y1: 230.97,
    x2: 328.41,
    y2: 235.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 933.91,
    y1: 248.97,
    x2: 327.91,
    y2: 253.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 933.41,
    y1: 266.97,
    x2: 333.41,
    y2: 271.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 932.91,
    y1: 284.97,
    x2: 332.91,
    y2: 289.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 932.41,
    y1: 302.97,
    x2: 332.41,
    y2: 307.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 931.91,
    y1: 320.97,
    x2: 335.91,
    y2: 325.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 931.41,
    y1: 338.97,
    x2: 335.41,
    y2: 343.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 930.91,
    y1: 356.97,
    x2: 337.91,
    y2: 361.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 930.41,
    y1: 374.97,
    x2: 337.41,
    y2: 379.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 929.91,
    y1: 392.97,
    x2: 336.91,
    y2: 397.97,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "1017.9 481.96 926.9 416.96 335.9 416.96 231.91 481.96",
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.35,462.18s2.31-68.26,39.23-106.81a103.48,103.48,0,0,0,28.38-59,174,174,0,0,0,.87-31.81",
    transform: "translate(-27.8 -50.55)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.95,240.13c-2.53,7.62-23.65,25.14-23.65,25.14s-6.47-26.68-3.94-34.3a14.54,14.54,0,0,1,27.6,9.15Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.76,289.91c-6.26,5-33.52,8.25-33.52,8.25s9.07-25.91,15.33-30.93a14.54,14.54,0,1,1,18.19,22.68Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.84,361.72c-7.94,1.17-33.1-9.8-33.1-9.8s20.91-17.79,28.85-19a14.54,14.54,0,0,1,4.25,28.76Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.75,411.8c-7.63,2.5-34.28-4.07-34.28-4.07s17.6-21.06,25.23-23.57a14.54,14.54,0,1,1,9.05,27.63Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.77,290c3.71,7.12,27.35,21.07,27.35,21.07s2.15-27.36-1.55-34.49A14.54,14.54,0,0,0,1088.77,290Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.16,349.06c5.67,5.69,32.4,11.92,32.4,11.92s-6.13-26.75-11.8-32.44a14.54,14.54,0,0,0-20.6,20.52Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.42,411.19c4.62,6.56,29.92,17.22,29.92,17.22s-1.52-27.41-6.15-34a14.54,14.54,0,1,0-23.77,16.75Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.35,523.18s2.31-68.26,39.23-106.81a103.48,103.48,0,0,0,28.38-59,174,174,0,0,0,.87-31.81",
    transform: "translate(-27.8 -50.55)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.95,301.13c-2.53,7.62-23.65,25.14-23.65,25.14s-6.47-26.68-3.94-34.3a14.54,14.54,0,0,1,27.6,9.15Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.76,350.91c-6.26,5-33.52,8.25-33.52,8.25s9.07-25.91,15.33-30.93a14.54,14.54,0,1,1,18.19,22.68Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.84,422.72c-7.94,1.17-33.1-9.8-33.1-9.8s20.91-17.79,28.85-19a14.54,14.54,0,0,1,4.25,28.76Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.75,472.8c-7.63,2.5-34.28-4.07-34.28-4.07s17.6-21.06,25.23-23.57a14.54,14.54,0,1,1,9.05,27.63Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.77,351c3.71,7.12,27.35,21.07,27.35,21.07s2.15-27.36-1.55-34.49A14.54,14.54,0,0,0,1103.77,351Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.16,410.06c5.67,5.69,32.4,11.92,32.4,11.92s-6.13-26.75-11.8-32.44a14.54,14.54,0,0,0-20.6,20.52Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.42,472.19c4.62,6.56,29.92,17.22,29.92,17.22s-1.52-27.41-6.15-34a14.54,14.54,0,1,0-23.77,16.75Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M245.2,158.35C245.69,139,259.09,122,278,117.85l.54-.11a11.42,11.42,0,0,1,2.32-.22h748.4a32,32,0,0,1,27.57,15.32l.19.33a13.12,13.12,0,0,1,1.72,6.33l6.95,393h-24l-8-384s0-11-10-12c-1.53-.15-20.09-.26-50.41-.33L955.7,468.51h-10l19.55-332.35c-133.3-.26-459.57.07-611,.25l19.42,330.1h-10L346.23,136.42l-57.64.07a24.21,24.21,0,0,0-20.89,12l-8,384h-24Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#e0e0e0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.57,540.6s-3.24-52.86,22.43-85.34a80.24,80.24,0,0,0,17.57-47.62A135,135,0,0,0,273.89,383",
    transform: "translate(-27.8 -50.55)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M289.95,362.46c-1.39,6.07-16.41,21.15-16.41,21.15s-7-20.12-5.57-26.18a11.27,11.27,0,1,1,22,5Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M300.41,400.24c-4.47,4.34-25.27,8.84-25.27,8.84s5.09-20.67,9.56-25a11.27,11.27,0,1,1,15.71,16.17Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M286.46,457.5c-6,1.49-26.27-5.13-26.27-5.13S275,437.1,281.06,435.61a11.27,11.27,0,1,1,5.4,21.89Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M266.14,498.45c-5.71,2.49-26.76-.62-26.76-.62s12-17.56,17.74-20a11.27,11.27,0,1,1,9,20.66Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8,405c3.38,5.23,22.66,14.25,22.66,14.25s-.35-21.28-3.74-26.51A11.27,11.27,0,1,0,251.8,405Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M228.65,453.15c4.79,4,25.89,6.82,25.89,6.82s-6.7-20.2-11.5-24.18a11.27,11.27,0,0,0-14.39,17.36Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.58,503.08c4.05,4.73,24.36,11.1,24.36,11.1s-3.19-21-7.25-25.77a11.27,11.27,0,0,0-17.12,14.68Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M289.95,362.46c-1.39,6.07-16.41,21.15-16.41,21.15s-7-20.12-5.57-26.18a11.27,11.27,0,1,1,22,5Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M300.41,400.24c-4.47,4.34-25.27,8.84-25.27,8.84s5.09-20.67,9.56-25a11.27,11.27,0,1,1,15.71,16.17Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M286.46,457.5c-6,1.49-26.27-5.13-26.27-5.13S275,437.1,281.06,435.61a11.27,11.27,0,1,1,5.4,21.89Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M266.14,498.45c-5.71,2.49-26.76-.62-26.76-.62s12-17.56,17.74-20a11.27,11.27,0,1,1,9,20.66Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8,405c3.38,5.23,22.66,14.25,22.66,14.25s-.35-21.28-3.74-26.51A11.27,11.27,0,1,0,251.8,405Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M228.65,453.15c4.79,4,25.89,6.82,25.89,6.82s-6.7-20.2-11.5-24.18a11.27,11.27,0,0,0-14.39,17.36Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M212.58,503.08c4.05,4.73,24.36,11.1,24.36,11.1s-3.19-21-7.25-25.77a11.27,11.27,0,0,0-17.12,14.68Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#fff",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,337.35c-.12-.15-.18-.25-.18-.25Z",
    transform: "translate(-27.8 -50.55)",
    fill: "url(#e2e6f350-b5ca-4a1b-97fa-8ad82b1378fe-176)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M575.34,351c-.19,6.37,3.76,8.76,3.76,8.76L616,392.44c14.24,5.16,16,32.23,16,32.23,1.4,2.5,2,6.84,2,12-.17,16-4.69,38.3-4.69,38.3l.13.21-.13.65.13.21-.13.65A39.53,39.53,0,0,0,631.6,480c-4,8.19-11.45,21.37-14.67,24.18-4.45,3.87-13.35,32.66-13.35,32.66l.29-.07-.29.93.19,0c-2.16,4.17-4.36,9.55-4.83,14.86a45.06,45.06,0,0,1-2.15,10.23,20.15,20.15,0,0,0-.33,11.93,51.64,51.64,0,0,1,1.74,9.59,60,60,0,0,0,4.55,18.15c4.07,9.67,9.46,22.88,9.74,25.54.15,1.44.5,3.56.9,5.75l-.23.06-9.57,21.7s-2.67,6-8,6a3.67,3.67,0,0,0-3.67,4.09,3.71,3.71,0,0,0,.23,1.78h0l0,.06c0,.1.09.2.13.3l.09.17c.05.1.11.19.18.29l.12.17.22.27.15.17.26.26.18.17.3.24.22.16.35.22.26.16.39.2.3.15.43.18.34.14.48.16.38.12.54.13.43.1.59.1.47.08.65.07.51.06.72,0,.54,0h1.37l.95,0,.53,0q.77,0,1.59-.13c17.36-1.72,30.26-15,30.26-15v-.25l0-.25v0l0-.25.06-.07s-1.12-17.29-7.47-21.2a53.23,53.23,0,0,1-1-9.75c0-12,3.56-24.07-6.23-43.84,0,0-.45-5.16,3.12-12.89a128,128,0,0,1,6.94-12.06l.44-.05-.71.94s11.57-.86,12.46-8.6a9.37,9.37,0,0,1,.45-1.89c2.68-7.78,15.62-18.81,21.36-19.6,6.23-.86,18.69,13.75,23.59,24.07.28.59.57,1.15.86,1.66,4.78,8.41,10.71,6.51,10.71,6.51-.21-.25-.39-.49-.58-.74a3.91,3.91,0,0,0,.58-.12,19.81,19.81,0,0,1-1.45-2c4.45,4.82,9.18,9.26,11.24,11.85,4.45,5.59,2.23,9.45,2.23,11.17,0,7.75-10.24,30.51-7.57,43,1.32,6.17-.19,13.39-2.06,19.11h-.39c-7.57,2.86-8.45,13.12-8.39,18.28,0,.16,0,.32,0,.47v0c0,.26,0,.51,0,.75v.16q0,.29,0,.56v.13c0,.2,0,.39,0,.56h0c0,.18,0,.35,0,.49v.06l0,.3v.08l0,.16v.11s21.36,9.45,39.61,12c.64.09,1.25.16,1.84.21l.54,0,1.15.07h1.56l.5,0c.35,0,.68,0,1-.08l.32,0q.62-.08,1.17-.2l.24-.06c.28-.07.54-.13.79-.21l.33-.11.59-.23.3-.14c.18-.09.35-.18.52-.28L745,674a5.84,5.84,0,0,0,.58-.43l0,0a5,5,0,0,0,.51-.51l.13-.16a4.54,4.54,0,0,0,.28-.38l.12-.2q.11-.19.19-.38l.09-.2a4.28,4.28,0,0,0,.14-.44l0-.15a4.43,4.43,0,0,0,.09-.59s0-.07,0-.11a4.65,4.65,0,0,0,0-.48c0-.06,0-.13,0-.19v0c.26-2.64-1.83-5.27-3.92-4.87-4.45.86-10.24-4.3-10.24-4.3l-12.17-19.88c-.19-4.65.33-10.56,3.27-15.36,5.79-9.45,12.91-29.65,12.91-29.65s-.89-12.46,2.67-18.48,0-15.47,0-15.47l-10.89-21c1.25,0,2,0,2,0l-.39-.86h.39s-13.35-29.65-18.69-33.09c-3.81-2.45-9.19-16.25-12-24,1.12-.59,1.74-1,1.74-1s3.12-37.39,3.12-61,16-33.09,16-33.09L758,365.79c9.79-3.87,11.13-13.75,11.13-13.75l-.11-.28c.08-.37.11-.58.11-.58l-.11-.28c.08-.37.11-.58.11-.58l-17.8-45.55c0,.14-.11.26-.16.39-1.26-7.85-5.15-20.14-17.2-21-17.8-1.29-24,7.74-20.47,8.6s18.69,6.88,18.69,6.88l6,9.67c-.39-.13-.61-.22-.61-.22a2.1,2.1,0,0,1,.87.63l.4.64c-.78-.22-1.26-.41-1.26-.41a1.65,1.65,0,0,1,.31.17,1.91,1.91,0,0,1,.25.16,2.87,2.87,0,0,1,.23.23,3.38,3.38,0,0,1,.23.25c.08.1.15.21.23.32l.12.18a14.23,14.23,0,0,1-1.36-.44c4.66,1.5,6.61,29.77,7,37l-23.05,10.27s-23.14,0-32.93,5.59c-8.59,4.9-12.73.87-13.61-.19q.9,1.15,1.59,2.22h0l-.25-.17-.23-.16-.19-.15-.21-.18-.07-.06a36.25,36.25,0,0,1-3.94-12.16,20.27,20.27,0,0,0-.32-16.4,5,5,0,0,0,1.22.63,18.82,18.82,0,0,1-2-6c-.22-2.35.45-4.85-.55-7a5.39,5.39,0,0,0-.36-.63c0-.07,0-.15-.08-.23-1-2.18-3.45-3.38-5-5.28-1-1.28-1.57-2.84-2.53-4.16a9.24,9.24,0,0,0-10.57-2.94c-1.46.59-2.82,1.58-4.4,1.61a9.89,9.89,0,0,1-2.41-.42,19,19,0,0,0-14.2,2.66,25.7,25.7,0,0,0-9.32,11,22,22,0,0,0-2.08,7,62.28,62.28,0,0,0,.12,7.65c.09,4.19-.53,8.59,1.26,12.4.11.24.25.45.37.68,0,.06,0,.12.07.18,1.7,3.63,5.26,6,8.67,8.29l4.41,2.91.5.33a24.14,24.14,0,0,0-3.8-.08c-6.68.43-20-6-20-6l-13.9-12.58,6.78-27.82-.26.19.26-1.05-.26.19.26-1.05c-.13.1-.25.19-.38.28l7.05-11.46s15.13-6,18.69-6.88-2.67-9.88-20.47-8.6c-13.1.95-16.56,15.39-17.47,23-.77-.85-1.22-1.47-1.22-1.47L577.31,341.3a21.06,21.06,0,0,0-2,8.86C575.33,350.45,575.33,350.74,575.34,351Zm100.86,15,.36.54,0,0Zm-35.67.12a5.92,5.92,0,0,0,2.57-1.7,22.2,22.2,0,0,0,3.44,1,14.36,14.36,0,0,1-1.33,3.13c-.17-.67-.25-1.08-.25-1.08A42.21,42.21,0,0,0,640.53,366.11ZM633,553.22c1-1.61,2-3.18,3-4.66C635.14,550.14,634,551.86,633,553.22Z",
    transform: "translate(-27.8 -50.55)",
    fill: "url(#e032e4db-4b5a-4772-82a4-e151341a8119-177)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M723.88,535.33l12.75,25.5s3.4,9.35,0,15.3-2.55,18.28-2.55,18.28-6.8,20-12.33,29.33-2.13,23-2.13,23l-22.1,2.55s8.5-16.58,6-28.91,7.23-34.84,7.23-42.51c0-1.7,2.13-5.53-2.13-11.05s-20.4-19.55-20-27.63Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#f7bbc3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M611.24,529.38s-8.16,11.3-9.11,22.3a46,46,0,0,1-2,10.11,20.6,20.6,0,0,0-.32,11.8,52.73,52.73,0,0,1,1.66,9.49,61.12,61.12,0,0,0,4.34,18c3.89,9.57,9,22.63,9.3,25.26.43,4.25,2.55,14.45,2.55,14.45l17,6.38s-5.1-12.33-5.1-24.23,3.4-23.8-6-43.36c0,0-.43-5.1,3-12.75s16.58-27.63,16.58-27.63Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#f7bbc3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M638.72,544.54c1.4,1.52-5.81,11.2-5.81,11.2s11.05-.85,11.9-8.5a9.54,9.54,0,0,1,.43-1.87c2.56-7.69,14.92-18.6,20.4-19.38,6-.85,17.85,13.6,22.53,23.8.27.59.54,1.13.82,1.64,4.57,8.32,10.23,6.44,10.23,6.44-3-3.7-3.62-6.63-2.68-9,3.72-9.17,31.58-8.9,31.58-8.9s-12.75-29.33-17.85-32.73-13.18-28.91-13.18-28.91-60.79-6.8-61.21-3.83-12.33,26.36-16.58,30.18S606.56,537,606.56,537c14.45-4.25,30.39,6.16,32.09,7.44Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M638.72,543.69c1.4,1.52-5.81,11.2-5.81,11.2s11.05-.85,11.9-8.5a9.54,9.54,0,0,1,.43-1.87c2.56-7.69,14.92-18.6,20.4-19.38,6-.85,17.85,13.6,22.53,23.8.27.59.54,1.13.82,1.64,4.57,8.32,10.23,6.44,10.23,6.44-3-3.7-3.62-6.63-2.68-9,3.72-9.17,31.58-8.9,31.58-8.9s-12.75-29.33-17.85-32.73-13.18-28.91-13.18-28.91-60.79-6.8-61.21-3.83-12.33,26.36-16.58,30.18-12.75,32.31-12.75,32.31c14.45-4.25,30.39,6.16,32.09,7.44Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#565171"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M718.57,638.84l11.69,19.77s5.53,5.1,9.78,4.25,8.5,11.9-8.93,9.35-37.83-11.9-37.83-11.9-1.91-17.22,7.86-21Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M615.7,632l-9.14,21.47s-2.55,6-7.65,6-6.8,10.63,9.78,8.93,28.91-14.88,28.91-14.88-1.28-20.4-8.93-21.68A32.61,32.61,0,0,0,615.7,632Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M718.57,639.69l11.69,19.77s5.53,5.1,9.78,4.25,8.5,11.9-8.93,9.35-37.83-11.9-37.83-11.9-1.91-17.22,7.86-21Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#b77983"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M615.7,632.89l-9.14,21.47s-2.55,6-7.65,6-6.8,10.63,9.78,8.93,28.91-14.88,28.91-14.88-1.28-20.4-8.93-21.68A32.61,32.61,0,0,0,615.7,632.89Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#b77983"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638,473.7c-.43,3-12.33,26.36-16.58,30.18-3.9,3.51-11.39,27.82-12.59,31.76-.77.15-1.53.32-2.29.54,0,0,8.5-28.48,12.75-32.31s16.15-27.21,16.58-30.18c.08-.59,2.57-.8,6.48-.74C639.71,473,638.08,473.22,638,473.7Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.77,525.13c6-.85,17.85,13.6,22.53,23.8.27.59.54,1.13.82,1.64,2.64,4.8,5.63,6.2,7.7,6.53-1.37.25-6,.46-9.83-6.53-.28-.51-.55-1.05-.82-1.64-4.29-9.36-14.65-22.28-20.93-23.7Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.72,543.69l-.07-.07c-1.37-1-12-8-23.65-8.43,12.45-.43,24.32,7.34,25.78,8.43l.07.07c1.23,1.34-4.19,9-5.52,10.8a19.37,19.37,0,0,1-2.41.39S640.12,545.21,638.72,543.69Z",
    transform: "translate(-27.8 -50.55)"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M748.11,313.44s0-25.93-17-27.21-23,7.65-19.55,8.5,17.85,6.8,17.85,6.8l9.35,15.73Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#f7bbc3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M594.23,319.39s0-25.93,17-27.21,23,7.65,19.55,8.5-17.85,6.8-17.85,6.8l-9.35,15.73Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#f7bbc3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M671.17,346.17s-1.28,17,9.35,26.78-24.65,22.1-24.65,22.1l-15.73-18.7s12.75-7.65,6-20.83Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#f7bbc3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M674.57,366.15s3.83,6,13.18.43S719.21,361,719.21,361l22.1-10.2s-1.7-36.56-6.8-38.26c0,0,10.2,4.25,13.18-4.25l17,45.06s-1.28,9.78-10.63,13.6l-35.28,21.68s-15.3,9.35-15.3,32.73-3,60.36-3,60.36-49.31,29.76-69.29-5.1c0,0,8.08-41.23,2.55-51.44,0,0-1.7-26.78-15.3-31.88L583.18,361s-6.8-4.25-1.7-16.58l11.9-29.33s7.23,10.2,13.18,5.1l-6.8,28.91,13.6,12.75s12.75,6.38,19.13,6,13.6,2.55,13.6,2.55,3,17,16.58,15.3C662.67,385.7,688.6,384.43,674.57,366.15Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M674.57,364.45s3.83,6,13.18.43,31.46-5.53,31.46-5.53l22.1-10.2s-1.7-36.56-6.8-38.26c0,0,10.2,4.25,13.18-4.25l17,45.06s-1.28,9.78-10.63,13.6L718.78,387s-15.3,9.35-15.3,32.73-3,60.36-3,60.36-49.31,29.76-69.29-5.1c0,0,8.08-41.23,2.55-51.44,0,0-1.7-26.78-15.3-31.88l-35.28-32.31s-6.8-4.25-1.7-16.58l11.9-29.33s7.23,10.2,13.18,5.1l-6.8,28.91,13.6,12.75s12.75,6.38,19.13,6,13.6,2.55,13.6,2.55,3,17,16.58,15.3C662.67,384,688.6,382.73,674.57,364.45Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M674.59,365.33l.17.23Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#d39999"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M583.18,360.2l35.28,32.31c13.6,5.1,15.3,31.88,15.3,31.88,5.53,10.2-2.55,51.44-2.55,51.44,20,34.86,69.29,5.1,69.29,5.1s.1-1.22.26-3.37c.14-1.88.33-4.48.54-7.57.28-4,.6-8.83.9-14.07.67-11.45,1.28-24.79,1.28-35.35,0-23.38,15.3-32.73,15.3-32.73l26.47-16.26,8.82-5.42c9.35-3.83,10.63-13.6,10.63-13.6l-17-45.06c-2.78,7.94-11.87,4.75-13.05,4.3,5,2.26,6.67,38.21,6.67,38.21l-22.1,10.2s-22.1,0-31.46,5.53c-8,4.7-11.91,1.1-12.91-.09,13.44,18-12.17,19.21-12.17,19.21-13.6,1.7-16.58-15.3-16.58-15.3s-7.23-3-13.6-2.55-19.13-6-19.13-6l-13.6-12.75,6.8-28.91c-6,5.1-13.18-5.1-13.18-5.1l-11.9,29.33C576.38,355.95,583.18,360.2,583.18,360.2Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#b45181"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M671.17,347.87a40.88,40.88,0,0,0,.41,8,20.82,20.82,0,0,1-24,12.53,15,15,0,0,0-1.51-11.16Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 624.46,
    cy: 295.84,
    r: 20.83,
    fill: "#f7bbc3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M652.59,334.54c.18,2.11.33,4.36-.64,6.24a11.3,11.3,0,0,1-2,2.56l-4.36,4.49a11.49,11.49,0,0,0-3.11,4.43c-1.26,4.2,2.46,8.37,2.34,12.76a5.68,5.68,0,0,1-6.44,2.38,11,11,0,0,1-2.69-1.49L631.42,363c-3.25-2.22-6.65-4.62-8.28-8.2-1.71-3.77-1.13-8.13-1.21-12.27a63.79,63.79,0,0,1-.11-7.57,22.3,22.3,0,0,1,2-6.94,25.21,25.21,0,0,1,8.9-10.83,17.65,17.65,0,0,1,13.56-2.63,9.15,9.15,0,0,0,2.3.41c1.51,0,2.81-1,4.2-1.59a8.64,8.64,0,0,1,10.09,2.91c.92,1.3,1.45,2.85,2.41,4.11,1.43,1.88,3.76,3.07,4.73,5.22s.32,4.61.53,6.93a19.08,19.08,0,0,0,1.89,5.95c-2.36-.82-3.51-3.4-5-5.38a13.25,13.25,0,0,0-9.75-4.94c-1.3-.06-3.71-.16-4.74.83C651.63,330.28,652.46,333,652.59,334.54Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M652.17,333.69c.18,2.11.33,4.36-.64,6.24a11.3,11.3,0,0,1-2,2.56L645.11,347A11.49,11.49,0,0,0,642,351.4c-1.26,4.2,2.46,8.37,2.34,12.76a5.68,5.68,0,0,1-6.44,2.38,11,11,0,0,1-2.69-1.49L631,362.18c-3.25-2.22-6.65-4.62-8.28-8.2-1.71-3.77-1.13-8.13-1.21-12.27a63.79,63.79,0,0,1-.11-7.57,22.3,22.3,0,0,1,2-6.94,25.21,25.21,0,0,1,8.9-10.83,17.65,17.65,0,0,1,13.56-2.63,9.15,9.15,0,0,0,2.3.41c1.51,0,2.81-1,4.2-1.59a8.64,8.64,0,0,1,10.09,2.91c.92,1.3,1.45,2.85,2.41,4.11,1.43,1.88,3.76,3.07,4.73,5.22s.32,4.61.53,6.93a19.08,19.08,0,0,0,1.89,5.95c-2.36-.82-3.51-3.4-5-5.38a13.25,13.25,0,0,0-9.75-4.94c-1.3-.06-3.71-.16-4.74.83C651.2,329.43,652,332.14,652.17,333.69Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#74585e"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674.75,365.54c-.12-.15-.18-.24-.18-.24Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.77,320.81a5.47,5.47,0,0,0,3.79-1.42l-.41,1.72A6,6,0,0,1,602.77,320.81Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.13,367.74c10.65,16.35-13.33,17.54-13.33,17.54a13.23,13.23,0,0,1-5.46-.39,14.21,14.21,0,0,0,3.33,0s25.7-1.27,12.08-19.32A6.92,6.92,0,0,0,678.13,367.74Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.62,367.43a17.93,17.93,0,0,1-5.11-.61,13.84,13.84,0,0,0,3,.19,27.88,27.88,0,0,1,7.87.79A25,25,0,0,0,634.62,367.43Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.48,343.62l11.9-29.33a21.73,21.73,0,0,0,1.54,1.87L583.61,344c-5.1,12.33,1.7,16.58,1.7,16.58l35.28,32.31c13.6,5.1,15.3,31.88,15.3,31.88,5.53,10.2-2.55,51.44-2.55,51.44,5.36,9.35,12.83,14,20.9,15.92-8.87-1.51-17.19-6.18-23-16.35,0,0,8.08-41.23,2.55-51.44,0,0-1.7-26.78-15.3-31.88L583.18,360.2S576.38,355.95,581.48,343.62Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.51,311.74a15.76,15.76,0,0,0,2.69.77c4.66,4.09,6.23,37.91,6.23,37.91l-22.1,10.2s-22.1,0-31.46,5.53c-4.58,2.71-7.83,2.66-10,1.91,2,.12,4.57-.41,7.83-2.33,9.35-5.53,31.46-5.53,31.46-5.53l22.1-10.2S739.61,313.44,734.51,311.74Z",
    transform: "translate(-27.8 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.22,312.68c3.23.42,7.67-.05,9.47-5.19l1,2.65C745.9,314.1,740.8,313.37,738.22,312.68Z",
    transform: "translate(-27.8 -50.55)"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M702.2,455.91c.67-11.45,1.28-24.79,1.28-35.35,0-23.38,15.3-32.73,15.3-32.73l26.47-16.26c-15.4,4-35.89,10.89-37.73,19-3,13.18-8.5,14.45-6.38,37A254.89,254.89,0,0,1,702.2,455.91Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M698.16,488.36s-3.83,11.9,6.8,19.55",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M638.65,488.36s-1.28,8.93-6.38,12.33",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M693.28,659.46s20.4,9.35,37.83,11.9c8.84,1.29,12.1-1.35,12.61-4.15.58,3.27-2,7.41-12.61,5.85-17.43-2.55-37.83-11.9-37.83-11.9a36,36,0,0,1-.14-4.25C693.17,658.46,693.28,659.46,693.28,659.46Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M608.26,668.38c16.58-1.7,28.91-14.88,28.91-14.88s-.63-10.06-3.65-16.49c3.39,6.35,4.08,17.34,4.08,17.34s-12.33,13.18-28.91,14.88c-8.47.87-12.17-1.48-13.08-4C597,667.4,600.76,669.15,608.26,668.38Z",
    transform: "translate(-27.8 -50.55)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M628.2,232.51A37.5,37.5,0,1,0,636,209.63,37.5,37.5,0,0,0,628.2,232.51Z",
    transform: "translate(-27.8 -50.55)",
    fill: "url(#796bd2e3-6922-48c9-8d61-1a37047129f5-178)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M629.58,232.51a36.13,36.13,0,1,0,7.51-22A36.12,36.12,0,0,0,629.58,232.51Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#e0e0e0"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 617.66,
    y1: 164.21,
    x2: 617.66,
    y2: 178.23,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 644.44,
    y1: 176.98,
    x2: 629.81,
    y2: 186.64,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 629.81,
    y1: 155.5,
    x2: 646.94,
    y2: 162.66,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 658.46,
    y1: 179.47,
    x2: 657.52,
    y2: 201.27,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 646.94,
    y1: 207.81,
    x2: 627.63,
    y2: 198.16,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 617.66,
    y1: 199.72,
    x2: 617.66,
    y2: 211.89,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 610.5,
    y1: 190.37,
    x2: 602.08,
    y2: 186.64,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 657.52,
    y1: 161.41,
    x2: 656.88,
    y2: 151.22,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 663.13,
    y1: 173.25,
    x2: 673.57,
    y2: 176.23,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "665.93 173.25 657.84 159.23 644.45 161.41 644.45 176.98 658.77 184.46 665.93 173.25",
    fill: "#6c63ff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M637.09,210.47l8.38,4.29c2.8-3.74,14.32-8.1,14.32-8.1l-1.2-9.57A36.08,36.08,0,0,0,637.09,210.47Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "631.99 185.08 617.35 178.23 609.25 189.75 617.66 203.14 631.99 200.96 631.99 185.08",
    fill: "#6c63ff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M672.24,256.49V268a36.12,36.12,0,0,0,23.29-15.15l-10.21-4.19Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M136.3,498.11a31.46,31.46,0,1,0,6.53-19.19A31.45,31.45,0,0,0,136.3,498.11Z",
    transform: "translate(-27.8 -50.55)",
    fill: "url(#fd3c50c2-1925-4067-85c5-f26d2d595195-179)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M137.46,498.11a30.3,30.3,0,1,0,6.29-18.49A30.3,30.3,0,0,0,137.46,498.11Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#e0e0e0"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 122.98,
    y1: 432.67,
    x2: 122.98,
    y2: 444.43,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 145.44,
    y1: 443.38,
    x2: 133.16,
    y2: 451.48,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 133.16,
    y1: 425.36,
    x2: 147.53,
    y2: 431.37,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 157.19,
    y1: 445.47,
    x2: 156.41,
    y2: 463.76,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 147.53,
    y1: 469.24,
    x2: 131.33,
    y2: 461.14,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 122.98,
    y1: 462.45,
    x2: 122.98,
    y2: 472.66,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 116.97,
    y1: 454.61,
    x2: 109.91,
    y2: 451.48,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 156.41,
    y1: 430.32,
    x2: 155.87,
    y2: 421.78,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 161.11,
    y1: 440.25,
    x2: 169.87,
    y2: 442.75,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.46 440.25 156.67 428.5 145.44 430.32 145.44 443.38 157.45 449.65 163.46 440.25",
    fill: "#6c63ff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M143.75,479.62l7,3.6c2.35-3.13,12-6.79,12-6.79l-1-8A30.26,30.26,0,0,0,143.75,479.62Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.99 450.17 122.72 444.43 115.92 454.09 122.98 465.32 134.99 463.49 134.99 450.17",
    fill: "#6c63ff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24,518.22v9.69a30.29,30.29,0,0,0,19.53-12.71l-8.56-3.51Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2,535.92a31.46,31.46,0,1,0,6.53-19.19A31.45,31.45,0,0,0,113.2,535.92Z",
    transform: "translate(-27.8 -50.55)",
    fill: "url(#1c0a27d4-1f07-420a-99e3-d67bda5d7f31-180)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M114.36,535.92a30.3,30.3,0,1,0,6.29-18.49A30.3,30.3,0,0,0,114.36,535.92Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#e0e0e0"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 99.88,
    y1: 470.48,
    x2: 99.88,
    y2: 482.23,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 122.34,
    y1: 481.19,
    x2: 110.07,
    y2: 489.29,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 110.07,
    y1: 463.17,
    x2: 124.43,
    y2: 469.18,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 134.09,
    y1: 483.28,
    x2: 133.31,
    y2: 501.56,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 124.43,
    y1: 507.05,
    x2: 108.24,
    y2: 498.95,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 99.88,
    y1: 500.26,
    x2: 99.88,
    y2: 510.47,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 93.87,
    y1: 492.42,
    x2: 86.81,
    y2: 489.29,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 133.31,
    y1: 468.13,
    x2: 132.77,
    y2: 459.59,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 138.01,
    y1: 478.06,
    x2: 146.77,
    y2: 480.56,
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.36 478.06 133.57 466.3 122.34 468.13 122.34 481.19 134.36 487.46 140.36 478.06",
    fill: "#6c63ff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M120.65,517.43l7,3.6c2.35-3.13,12-6.79,12-6.79l-1-8A30.26,30.26,0,0,0,120.65,517.43Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.89 487.98 99.62 482.23 92.83 491.9 99.88 503.13 111.89 501.3 111.89 487.98",
    fill: "#6c63ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.14,556v9.69A30.29,30.29,0,0,0,169.67,553l-8.56-3.51Z",
    transform: "translate(-27.8 -50.55)",
    fill: "#6c63ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawGoal0V5V1);
export default __webpack_public_path__ + "static/media/undraw_goal_-0-v5v(1).7c7bf5116857601d1751be82363b32e8.svg";
export { ForwardRef as ReactComponent };